import logoutAndRedirect from "utils/logoutHelper";

function isLoginRequest(input) {
  const url = typeof input === "string" ? input : input?.url ?? "";
  return /\/api\/auth\/login|auth\/login/i.test(String(url));
}

/**
 * Wraps fetch: on 401 from protected routes, clears session and sends user to sign-in.
 * Login requests are excluded so wrong-password responses stay on the form.
 */
export async function apiFetch(input, init) {
  const res = await fetch(input, init);
  if (res.status === 401 && !isLoginRequest(input)) {
    logoutAndRedirect();
    throw new Error("Session expired");
  }
  return res;
}
